import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { get } from 'lodash';

import NotificationWrapper from '../../notifications/NotificationsWrapper';
import Spinner from '../../sharedComponents/Spinner/Spinner';
import ReservationHistoryRow from './ReservationHistoryRow';
import * as SecurityHelper from '../../../helpers/securityHelper';

export default class ReservationHistory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            history: [],
            isLoading: true,
            error: false,
            location: '',
            timeZone: 'America/New_York'
        };
    }

    getTimeZoneFromLocation = (assetId)  => {
        let timeZone = 'America/New_York';
        const searchURL = `${process.env.API}/search?fq=entity_id:${assetId}`;

        axios.get(searchURL)
        .then((searchResponse) => {
            if (get(searchResponse, 'data.results', []).length > 0) {
                const location = searchResponse.data.results[0];
                if (location.time_zone) {
                    timeZone = location.time_zone;
                }
            }
            this.setState({ timeZone });
        })
        .catch(()=>{
            this.setState({ timeZone });
        });
    };

    componentDidMount() {
        let url = `${process.env.API}/orders/reservations/${this.props.reservationID}`;
        let auth = SecurityHelper.getAuthHeader();
        if (this.props.isInternal) {
            url = `${process.env.API}/orders/internal/reservations/${this.props.reservationID}`;
            auth = SecurityHelper.getInternalAuthHeader();
        }

        axios.get(url, { headers: { Authorization: auth } })
            .then((resp) => {
                this.setState({
                    history: resp.data.reservation_history,
                    location: resp.data.location_id,
                    isLoading: false
                });
                this.getTimeZoneFromLocation(resp.data.location_id);
            })
            .catch(() => {
                this.setState({
                    error: true,
                    isLoading: false
                });
            });
    }

    getRows = () => {
        const data = this.state.history;
        const rows = data.map((row, index) => {
            return (
                <ReservationHistoryRow
                    rowData={row}
                    key={index}
                    location={this.state.location}
                    timeZone={this.state.timeZone}
                    isInternal={this.props.isInternal} />
            );
        });

        return rows;
    };

    render() {
        if (this.state.isLoading) {
            return (
                <Spinner isSpinning={this.state.isLoading} size="lg" />
            );
        }
        if (this.state.error) {
            return (
                <NotificationWrapper noticeType="error">
                    <div className="rec-notification-title">System Error</div>
                    <p>There was an error pulling the history for this reservation.</p>
                </NotificationWrapper>
            );
        }

        if (!this.state.history || this.state.history.length === 0) {
            return (
                <NotificationWrapper noticeType="info">
                    <div className="rec-notification-title">Info</div>
                    <p>No history exists for this reservation.</p>
                </NotificationWrapper>
            );
        }

        return (
            <div>
                <table>
                    <thead>
                    <tr>
                        <th>Action Time</th>
                        <th>Order ID</th>
                        <th>Reservation Number</th>
                        <th>Internal Account</th>
                        <th>Action Performed</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.getRows()}
                    </tbody>
                </table>
                <small>Reservation History is available for actions as of October 2019</small>
            </div>
        );
    }
}

ReservationHistory.propTypes = {
    reservationID: PropTypes.string.isRequired,
    isInternal: PropTypes.bool.isRequired
};
